import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import NavSelect from '../../../components/NavSelect';
import BobModal from '../../../components/BobModal';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as BobActions from '../../../actions/bobActions';

const NavModal = ({
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    fetchNavClients,
    fetchNavEquipment,
    fetchNavSites,
    fetchNavSystems,
    handleGo,
    navClients,
    navClientsMeta,
    navEquipment,
    navEquipmentMeta,
    navSites,
    navSitesMeta,
    navSystems,
    navSystemsMeta,
    targetNavClient,
    targetNavCompany,
    targetNavEquipment,
    targetNavSite,
    targetNavSystem,
    setNavClient,
    setNavCompany,
    setNavSite,
    setNavEquipment,
    setNavSystem,
    setNavModalOpen,
    menu,
    ...props
}) => {
    const [menuType, setMenuType] = useState(null);

    useEffect(() => {
        setMenuType(menu);
    }, [menu]);

    const isValidSubmit = () => {
        if (menuType === 'company') {
            if (!isEmpty(targetNavCompany)) {
                return false;
            }
        } else if (menuType === 'client') {
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient)) {
                return false;
            }
        } else if (menuType === 'site') {
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient) && !isEmpty(targetNavSite)) {
                return false;
            }
        } else if (menuType === 'equipment') {
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient) && !isEmpty(targetNavSite) && !isEmpty(targetNavEquipment)) {
                return false;
            }
        } else if (menuType === 'system') {
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient) && !isEmpty(targetNavSite) && !isEmpty(targetNavSystem)) {
                return false;
            }
        }
        return true;
    };

    return (
        <BobModal
            title="Select"
            confirmText="Ok"
            onClose={setNavModalOpen}
            onConfirm={handleGo}
            disabled={isValidSubmit()}
        >
            <NavSelect
                disabled
                fetchChildren={fetchNavClients}
                isFromModal={true}
                setTarget={setNavCompany}
                targetId={targetNavCompany.id}
                targetName={targetNavCompany.name}
                title={'Company'}
            />
            {menuType === 'site' || menuType === 'equipment' || menuType === 'client' || menuType === 'system' ?
                <NavSelect
                    fetchChildren={fetchNavSites}
                    isFromModal={true}
                    meta={navClientsMeta}
                    parentId={targetNavCompany.id}
                    results={navClients}
                    search={fetchNavClients}
                    setTarget={setNavClient}
                    targetId={targetNavClient.id ? targetNavClient.id : ''}
                    targetName={targetNavClient.name ? targetNavClient.name : ''}
                    title={'Client'}
                /> : ''
            }
            {menuType === 'site' || menuType === 'equipment' || menuType === 'system' ?
                <NavSelect
                    fetchChildren={menuType === 'system' ? fetchNavSystems : fetchNavEquipment}
                    isFromModal={true}
                    meta={navSitesMeta}
                    parentId={targetNavClient.id}
                    results={navSites}
                    search={fetchNavSites}
                    setTarget={setNavSite}
                    targetId={targetNavSite.id ? targetNavSite.id : ''}
                    targetName={targetNavSite.name ? targetNavSite.name : ''}
                    title={'Site'}
                /> : ''
            }
            {menuType === 'equipment' ?
                <NavSelect
                    entityType={'equipment'}
                    isFromOverview={true}
                    meta={navEquipmentMeta}
                    isFromModal={true}
                    parentId={targetNavSite.id}
                    results={navEquipment}
                    search={fetchNavEquipment}
                    setTarget={setNavEquipment}
                    targetId={targetNavEquipment.id ? targetNavEquipment.id : ''}
                    targetName={targetNavEquipment.name ? targetNavEquipment.name : ''}
                    title={'Equipment'}
                /> : ''}
            {menuType === 'system' ?
                <NavSelect
                    entityType={'system'}
                    isFromOverview={true}
                    meta={navSystemsMeta}
                    isFromModal={true}
                    parentId={targetNavSite.id}
                    results={navSystems}
                    search={fetchNavSystems}
                    setTarget={setNavSystem}
                    targetId={targetNavSystem.id ? targetNavSystem.id : ''}
                    targetName={targetNavSystem.name ? targetNavSystem.name : ''}
                    title={'System'}
                /> : ''}
        </BobModal> 
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavClient:    state.bob.activeNavClient,
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavSite:      state.bob.activeNavSite,
        navClients:         state.bob.navClients,
        navClientsMeta:     state.bob.navClientsMeta,
        navEquipment:       state.bob.navEquipment,
        navEquipmentMeta:   state.bob.navEquipmentMeta,
        navSites:           state.bob.navSites,
        navSitesMeta:       state.bob.navSitesMeta,
        navSystems:         state.bob.navSystems,
        navSystemsMeta:     state.bob.navSystemsMeta,
        targetNavClient:    state.bob.targetNavClient,
        targetNavCompany:   state.bob.targetNavCompany,
        targetNavEquipment: state.bob.targetNavEquipment,
        targetNavSite:      state.bob.targetNavSite,
        targetNavSystem:    state.bob.targetNavSystem
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...BobActions
};

export default connect(mapStateToProps, mapDispatchToProps)(NavModal);
